/**
 * 协议层接口请求
 * @type {{}}
 */
import API from './api'
import Request from './http'
import data from '../../const'

export const post = {

  /**
   * 获取banner
   * @param params
   * @returns {*|Promise<any>}
   */
  getChannel: function (params) {
    return Request.post(API.API_GET_CHANNEL, params)
  },

  /**
   * 获取渠道活动
   */
  getActivityList: function (params) {
    return Request.post(API.API_GET_ACTIVITY, params)
  },

  /**
   * 获取验证码
   */
  getCode: function (params) {
    return Request.post(API.API_SEND_CODE, params)
  },

  /**
   * 登录
   */
  login: function (params) {
    return Request.post(API.API_LOGIN, params)
  },
  /**
   * oAuth登录
   */
  oAuthLogin: function (params) {
    return Request.get(API.API_O_AUTH_LOGIN, null, { headers: { token: params.authorizationToken } })
  },
  /**
   * oAuth登录
   */
  getOpenId: function (params) {
    return Request.post(API.API_WEIXIN_OPENID, params)
  },
  /**
   * oAuth登出
   */
  handleLogout: function (params) {
    return Request.post(API.API_LOGOUT, params)
  },
  /**
   * 更新用户信息
   * @param params
   * @returns {*|Promise<any>}
   */
  updataUserInfo: function (params) {
    return Request.post(API.API_UPDATA_USER_INFO, params)
  },

  /**
   * 获取文书模板列表
   * @param params
   * @returns {*|Promise<any>}
   */

  getDocModuleList: function (params) {
    return Request.post(API.API_DOC_MODULE, params)
  },
  /**
   * 获取文书订单参数
   */
  getDocParams: function (params) {
    return Request.post(API.API_DOC_PARAMS, params)
  },

  /**
   * 导出到邮箱
   */
  exportEmail: function (params) {
    return Request.post(API.API_EXPORT_EMAIL, params)
  },

  /**
   * 获取二级领域标签
   */
  subField: function (params) {
    return Request.post(API.API_SUBFIELD_LIST, params)
  },
  /**
   * 创建电话订单
   */
  createTelOrder: function (params) {
    return Request.post(API.API_CREATE_TEL_ORDER, params)
  },

  /**
   * 查看订单
   */
  orderList: function (params) {
    return Request.post(API.API_OEDER_LIST, params)
  },

  /**
   * 查看电话订单
   */
  orderDetail: function (params) {
    return Request.post(API.API_TEL_DETAIL, params)
  },
  /**
   * 查看电话订单
   */
  docDetail: function (params) {
    return Request.post(API.API_DOC_DETAIL, params)
  },

  /**
   * 优惠券列表
   */
  couponList: function (params) {
    return Request.post(API.API_COUPON_LIST, params)
  },

  /**
   * 创建文书订单
   */
  docOrder: function (params) {
    return Request.post(API.API_DOC_ORDER, params)
  },

  /**
   * 创建文书订单
   */
  docOrderEdit: function (params) {
    return Request.post(API.API_DOC_ORDEREDIT, params)
  },

  /**
   ** 订单支付
   */
  payOrder: function (params) {
    return Request.post(API.API_PAY_ORDER, params)
  },

  /**
   * 创建订单
   */
  createOrder: function (params) {
    return Request.post(API.API_CREATE_ORDER, params)
  },

  /**
   * 获取产品列表
   */
  productList: function (params) {
    return Request.post(API.API_PRODUCT_LIST, params)
  },
  /**
   * 获取产品列表
   */
  commtEval: function (params) {
    return Request.post(API.API_COMMIT_EVAL, params)
  },

  /**
   * 文书报价列表
   */
  quotedList: function (params) {
    return Request.post(API.API_QUOTED_LIST, params)
  },

  /**
   * 选择文书报价
   */
  choooseQuoted: function (params) {
    return Request.post(API.API_CHOOSE_QUOTED, params)
  },
  /**
   * 确认文书报价
   */
  confirmDocOrder: function (params) {
    return Request.post(API.API_COMFIRM_QUOTED, params)
  },

  /**
    *取消文书报价
    */
  cancelQuoted: function (params) {
    return Request.post(API.API_CANCEL_QUOTED, params)
  },

  /**
    *是否有优惠活动
    */
  whichActive: function (params) {
    return Request.post(API.API_WHICH_ACTIVE, params)
  },

  /**
    *获取优惠券
    */
  getActive: function (params) {
    return Request.post(API.API_GET_COUPPON, params)
  },

  /**
    *见面咨询下单
    */
  faceOrder: function (params) {
    return Request.post(API.API_FACE_ORDER, params)
  },

  /**
    *保存三要素
    */
  saveThreeElements: function (params) {
    return Request.post(API.API_GET_USER_SAVE_THREE_ELEMENTS, params)
  },

  /**
    *发律师函下单
    */
  letterOrder: function (params) {
    return Request.post(API.API_LETTER_ORDER, params)
  },

  /**
  *发律师函详情
  */
  letterOrderEdit: function (params) {
    return Request.post(API.API_LETTER_ORDEREDIT, params)
  },

  /**
    *代打官司下单
    */
  lawsuitOrder: function (params) {
    return Request.post(API.API_LAWSUIT, params)
  },

  /**
    *律师起草下单
    */
  draftOrder: function (params) {
    return Request.post(API.API_DRAFT_ORDER, params)
  },
  /**
    *律师起草下单
    */
  getRecommendProducts: function (params) {
    return Request.post(API.API_RECOMMEND_PRODUCTS, params)
  },
  /**
    *律师起草下单
    */
  getProductDetail: function (params) {
    return Request.post(API.API_PRODUCT_DETAIL, params)
  },
  /**
    *律师起草下单
    */
  productPrice: function (params) {
    return Request.post(API.API_PRODUCT_PRICE, params)
  },
  /**
    *发律师函订单详情
    */
  // letterDetail: function (params) {
  //   return Request.post(API.API_LAWSUIT, params)
  // },
  cancelOrder: function (params) {
    return Request.post(API.API_CANCEL_ORDER, params)
  },
  continueConsultOrder: function (params) {
    return Request.post(API.API_ORDER_CONTINUE_CONSULT_ORDER, params)
  },
  codeForChangeMobile: function (params) {
    return Request.post(API.API_CODE_FOR_CHANGE_MOBILE, params)
  },
  /**
   *修改手机号
   */
  changeMobile: function (params) {
    return Request.post(API.API_CHANGE_MOBILE, params)
  },
  wxShare: function (params) {
    return Request.post(API.API_WX_SHARE, params)
  },
  /**
   *评价订单
   */
  evaluateOrder: function (params) {
    return Request.post(API.API_ORDER_EVALUATEORDER, params)
  },
  /**
   *评价页面我要委托
   */
  contractsOrder: function (params) {
    return Request.post(API.API_CONTRACTS, params)
  },
  /**
   *评价订单
   */
  vcCreateOrder: function (params) {
    return Request.post(API.API_VCORDER_CREATE, params)
  },

  /**
   *视频律师取消
   */
  cancelVideo: function (params) {
    return Request.post(API.API_CANCEL_VIDEO_ORDER, params)
  },

  /**
  *律师起草下单
  */
  getVideoDetail: function (params) {
    return Request.post(API.API_DETAIL_VIDEO_ORDER, params)
  },

  /**
   * 上传文书图片
   * @param params
   * @param files
   * @param onProgress
   * @returns {*}
   */
  docUpload: function (params, files, onProgress) {
    if (!params) {
      params = {}
    }
    if (!onProgress) {
      onProgress = () => {
      }
    }
    const promise = new Promise(function (resolve, reject) {
      if (files) {
        console.log(files)
        let count = files.length
        let time = new Date().getTime()

        let list = []
        let progress = 1
        for (let index = 0; index < count; index++) {
          let file = files[index]
          if (!file) continue
          let newParams = {}
          newParams = Object.assign(newParams, params)
          newParams.slice = (index + 1)
          newParams.countSlice = count
          newParams.type = data.fileType.docType
          newParams.uuid = time
          newParams.unionPayFile = file
          list.push(Request.post(API.API_DOC_UPLOAD, newParams, {
            onUploadProgress: (e) => {
              let pres = ~~((progress++ / count) * 100)
              if (pres > 90) {
                pres = 90
              }
              onProgress(pres)
            }
          }))
        }
        Request.all(list).then((listRes) => {
          if (listRes instanceof Array) {
            listRes.forEach((item) => {
              if (item.data && item.data['url']) {
                onProgress(100)
                resolve({path: item.data['url']})
              }
            })
          }
        }).catch((err) => {
          reject(err)
        })
      }
      // reject('err files is empty !!!')
    })

    return promise
  }

}

export default post



// WEBPACK FOOTER //
// ./src/libs/request/post.js